import type {
  CrmLeadFunnelListItem,
  CrmLeadFunnelShort,
} from '@/api/types/crm/crmLeadFunnels.types'

export type LeadFunnelView = {
  id: number
  name: string
  isPrimary: boolean
  manager_id?: number | null
}

export type LeadWithFunnels = Omit<CrmLeadFunnelListItem, 'funnels'> & {
  id: number
  funnels: LeadFunnelView[]
  funnel_id?: number | null
}

export type LeadsTableRow = LeadWithFunnels & {
  rowId: string
  currentFunnelId: number | null
  currentFunnelStatusId?: number | null
  currentFunnelStatusName?: string | null
  currentFunnelStatusColor?: string | null
}

const mapFunnels = (
  funnels: CrmLeadFunnelShort[],
  currentFunnelId: number | null,
): LeadFunnelView[] => {
  return funnels.map((funnel) => ({
    id: funnel.id,
    name: funnel.name,
    isPrimary: currentFunnelId !== null && funnel.id === currentFunnelId,
  }))
}

const mapResponseItemToTableRow = (item: CrmLeadFunnelListItem): LeadsTableRow => {
  const currentFunnelId = item.funnel?.id ?? null
  const leadId = item.id ?? item.lead?.id

  return {
    ...item,
    id: leadId ?? 0,
    fields: item.fields,
    funnels: mapFunnels(item.funnels ?? [], currentFunnelId),
    rowId: String(item.lead_funnel_id),
    currentFunnelId,
    currentFunnelStatusId: item.current_status?.id ?? null,
    currentFunnelStatusName: item.current_status?.name ?? null,
    currentFunnelStatusColor: item.current_status?.color ?? null,
  }
}

export const mapLeadsToTableRows = (
  funnelLeadItems: CrmLeadFunnelListItem[],
): LeadsTableRow[] => funnelLeadItems.map(mapResponseItemToTableRow)
